import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconSharedSvg } from './IconSharedSvg';

export type IconSharedProps = UseIconProps;

export function IconShared(props: IconSharedProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconSharedSvg} {...iconProps} />;
}
